module.exports = __webpack_public_path__ + "images/pages/for_business/sp/btn_7_9f80fc46e8f1db486a6e5f5dc4fa3d3f.png";